/*  ========================================================================
    # Scripts - Starkmacher
    ========================================================================  */

import { popup } from 'leaflet';

/**
 * Script that handles the Starkmacher page.
 */

const Starkmacher = {
  cfg: {
    slotEntries: document.querySelectorAll('.sm-hero__slotmachine-entry'),
    popup: null,
    popupTitle: null,
    popupMedia: null,
    popupMediaPlaceholder: null,
    popupExcerpt: null,
    popupShowMore: null,
    popupMediaContainer: null,
    smVideo: null,
    activeSlide: 0,
    activeCategorySlug: '',
    posts: [],
    greyIcon: null,
    greyIconSmall: null,
    redIcon: null,
    redIconSmall: null,
    popupOpen: false,
    openpopupID: 0,
    markers: [],
    map: null,
    activeEntry: null,
    animatedMarker: null,
    activeMarker: null,
    activeMarkers: [],
    spaceBarPressedMarker: null
  },

  /**
   * Function to check if user prefers reduced motion
   * */
  prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  },

  /**
   * Creates an object for each accordion section on the current page.
   */
  initSlotMachine() {
    // entries
    const entries = document.querySelectorAll('.sm-hero__slotmachine-entry');
    this.cfg.slotEntries = entries;
    let chosenEntry = null;

    // first loop to get the correct active Slide
    entries.forEach(entry => {
      if (entry.dataset.active == 1) {
        chosenEntry = entry;
        this.cfg.activeSlide = parseInt(entry.dataset.value, 10);
      }
    });

    // set the slot machine to opacity 1
    document
      .querySelector('.sm-hero__slotmachine-entries')
      ?.classList.add('sm-hero__slotmachine-entries--active');

    // initial update the offsets, so it does not look awful
    this.updateOffsets(entries);

    // check if there is an entry which is active and then initiate a scroll to the chosen entry
    if (chosenEntry !== null) {
      const index = entries.length;

      const intervalId = setInterval(() => {
        if (this.cfg.activeSlide < entries.length - 1) this.cfg.activeSlide += 1;
        else this.cfg.activeSlide = 0;
        this.updateOffsets(entries);
      }, 200);

      setTimeout(() => {
        clearInterval(intervalId);
      }, index * 200);
    }

    // up and down buttons
    const upButton = document.querySelector('.sm-hero__slotmachine-up');
    const downButton = document.querySelector('.sm-hero__slotmachine-down');

    upButton?.addEventListener('click', () => {
      if (this.cfg.activeSlide > 0) this.cfg.activeSlide -= 1;
      else this.cfg.activeSlide = entries.length - 1;

      this.updateOffsets(entries);
      this.setNewURLParameter(entries);
      this.updateMarker();
      this.centerMap();
      this.closePopup();
    });

    downButton?.addEventListener('click', () => {
      if (this.cfg.activeSlide < entries.length - 1) {
        this.cfg.activeSlide += 1;
      } else this.cfg.activeSlide = 0;

      this.updateOffsets(entries);
      this.setNewURLParameter(entries);
      this.updateMarker();
      this.centerMap();
      this.closePopup();
    });

    // randomizer
    const randomButton = document.querySelector('.sm-hero__slotmachine-random');
    randomButton?.addEventListener('click', () => {
      const intervalId = setInterval(() => {
        if (this.cfg.activeSlide < entries.length - 1) this.cfg.activeSlide += 1;
        else this.cfg.activeSlide = 0;
        this.updateOffsets(entries);
      }, 200);

      const randomNumber = Math.floor(Math.random() * (8 - 4 + 1)) + 4;
      setTimeout(() => {
        clearInterval(intervalId);
        this.setNewURLParameter(entries);
        this.updateMarker();
        this.centerMap();
      }, randomNumber * 200);

      this.closePopup();
    });

    // initial chosen category
  },

  getSlideOffset(index, entriesLength) {
    const activeSlide = this.cfg.activeSlide;
    const delta = index - activeSlide;

    if (activeSlide == 0 && index == entriesLength - 1) return -1;
    if (activeSlide == 0 && index == entriesLength - 2) return -2;
    if (activeSlide == 1 && index == entriesLength - 1) return -2;

    if (activeSlide == entriesLength - 1 && index == 0) return 1;
    if (activeSlide == entriesLength - 1 && index == 1) return 2;

    if (activeSlide == entriesLength - 2 && index == 0) return 2;

    if (delta <= -3) return -2;
    if (delta >= 3) return 2;

    return delta;
  },

  updateOffsets(entries) {
    // update every entry and their offset
    entries.forEach(entry => {
      entry.dataset.offset = this.getSlideOffset(entry.dataset.value, entries.length);
    });
  },

  setNewURLParameter(entries) {
    // set the new url parameter
    const url = new URL(window.location.href);
    url.searchParams.set('cat', entries[this.cfg.activeSlide].dataset.slug);
    window.history.pushState({}, '', url.toString());
  },

  initMap() {
    const mapElement = document.getElementById('map');
    this.cfg.popup = document.getElementsByClassName('sm-map__popup');
    this.cfg.popupTitle = document.getElementsByClassName('sm-map__popup-title')[0];
    this.cfg.popupExcerpt = document.getElementsByClassName('sm-map__popup-excerpt')[0];
    this.cfg.popupMedia = document.getElementsByClassName('sm-map__popup-media')[0];
    const popupClose = document.getElementsByClassName('sm-map__popup-close');
    this.cfg.popupShowMore = document.getElementsByClassName('sm-map__popup-show-more')[0];
    this.cfg.popupMediaContainer = document.getElementsByClassName(
      'sm-map__popup-media-container'
    )[0];
    const smModal = document.getElementById('sm-dialog');
    this.cfg.smVideo = document.getElementById('sm-dialog__video');
    this.cfg.popupMediaPlaceholder = document.getElementsByClassName(
      'sm-map__popup-placeholder'
    )[0];

    const map = L.map(mapElement, {
      center: [50.359914, 7.592073],
      zoom: 4,
      scrollWheelZoom: false, // Disable scroll wheel zoom
      gestureHandling: true,
      gestureHandlingOptions: {
        text: {
          touch: 'Benutzen sie zwei Finger um die Karten zu scrollen',
          scroll: 'Benutzen Sie STRG + Mausrad, um zu zoomen',
          scrollMac: 'Benutzen Sie \u2318 + Mausrad, um zu zoomen'
        }
      }
    });
    this.cfg.map = map;

    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 19
    }).addTo(map);

    // markers
    const greyIcon = L.icon({
      iconUrl:
        '/wp-content/themes/sparkassekoblenz-magazin/system/graphics/misc/starkmacher_pin_grey.svg',
      iconSize: [35, 48],
      iconAnchor: [18, 48],
      popupAnchor: [0, -48]
    });
    this.cfg.greyIcon = greyIcon;

    const greyIconSmall = L.icon({
      iconUrl:
        '/wp-content/themes/sparkassekoblenz-magazin/system/graphics/misc/starkmacher_pin_grey.svg',
      iconSize: [25, 34],
      iconAnchor: [12, 36],
      popupAnchor: [0, -36]
    });
    this.cfg.greyIconSmall = greyIconSmall;

    const redIcon = L.icon({
      iconUrl:
        '/wp-content/themes/sparkassekoblenz-magazin/system/graphics/misc/starkmacher_pin_red.svg',
      iconSize: [35, 48],
      iconAnchor: [18, 48],
      popupAnchor: [0, -48]
    });
    this.cfg.redIcon = redIcon;

    const redIconSmall = L.icon({
      iconUrl:
        '/wp-content/themes/sparkassekoblenz-magazin/system/graphics/misc/starkmacher_pin_red.svg',
      iconSize: [25, 34],
      iconAnchor: [12, 36],
      popupAnchor: [0, -36]
    });
    this.cfg.redIconSmall = redIconSmall;

    // Sort markers by latitude (top to bottom) and then by longitude (left to right)
    this.cfg.posts.sort((a, b) => {
      // First sort by latitude (descending order for north to south)
      if (a.location.lat !== b.location.lat) {
        return b.location.lat - a.location.lat;
      }
      // If latitudes are equal, sort by longitude (ascending order for west to east)
      return a.location.lng - b.location.lng;
    });

    // create the marker
    this.cfg.posts.forEach(entry => {
      const entryMarker = L.marker([entry.location.lat, entry.location.lng]).addTo(map);

      const customGreyIconSmall = L.icon({
        ...this.cfg.greyIconSmall,
        alt: 'entry.title' // Dynamic alt text using entry title
      });
      const customGreyIcon = L.icon({
        ...this.cfg.greyIcon,
        alt: entry.title // Dynamic alt text using entry title
      });

      const customRedIconSmall = L.icon({
        ...this.cfg.redIconSmall,
        alt: entry.title // Dynamic alt text using entry title
      });

      const customRedIcon = L.icon({
        ...this.cfg.redIcon,
        alt: entry.title // Dynamic alt text using entry title
      });

      entryMarker.on('click', e => {
        // Pop is already open
        if (this.cfg.popupOpen) {
          if (this.cfg.openpopupID == entry.ID) {
            // reset the icon to the small version
            if (entry.cat[0].slug === this.cfg.slotEntries[this.cfg.activeSlide].dataset.slug) {
              entryMarker.setIcon(customRedIconSmall);
            } else {
              entryMarker.setIcon(customGreyIconSmall);
            }

            // close popup
            this.cfg.popupOpen = false;
            this.cfg.activeMarker = null;
            this.cfg.popup[0].classList.toggle('sm-map__popup--active');
            this.cfg.activeEntry = null;
          } else {
            // reset the last icon to the small version
            if (this.cfg.activeMarker && this.cfg.activeEntry) {
              if (
                this.cfg.activeEntry.cat[0].slug ===
                this.cfg.slotEntries[this.cfg.activeSlide].dataset.slug
              ) {
                this.cfg.activeMarker.setIcon(customRedIconSmall);
              } else {
                this.cfg.activeMarker.setIcon(customGreyIconSmall);
              }
            }
            this.cfg.activeMarker = entryMarker;
            // change content of popup
            this.cfg.openpopupID = entry.ID;
            this.setPopupContent(entry);

            if (entry.cat[0]?.slug === this.cfg.slotEntries[this.cfg.activeSlide].dataset.slug) {
              this.cfg.activeMarker.setIcon(redIcon);
            } else {
              this.cfg.activeMarker.setIcon(greyIcon);
            }
          }
        } else {
          if (entry.cat[0].slug === this.cfg.slotEntries[this.cfg.activeSlide].dataset.slug) {
            entryMarker.setIcon(redIcon);
          } else {
            entryMarker.setIcon(greyIcon);
          }
          // change content of popup and open it
          this.setPopupContent(entry);

          this.cfg.popupOpen = true;
          this.cfg.openpopupID = entry.ID;
          this.cfg.activeMarker = entryMarker;
          this.cfg.activeEntry = entry;
          this.cfg.popup[0].classList.add('sm-map__popup--active');
        }

        if (window.innerWidth < 576) this.centerMapToPin();

        if (this.cfg.animatedMarker == e.target._icon) {
          this.cfg.animatedMarker.classList.remove('animated-marker');
          this.cfg.animatedMarker = null;
        } else {
          if (this.cfg.animatedMarker !== null)
            this.cfg.animatedMarker.classList.remove('animated-marker');
          this.cfg.animatedMarker = e.target._icon;
          this.cfg.animatedMarker.classList.add('animated-marker');
        }
      });

      // add the Eventlistener to the mediaContainer
      this.cfg.popupMediaContainer.addEventListener('click', () => {
        if (
          this.cfg.popupMediaContainer.classList.contains('sm-map__popup-media-container--active')
        ) {
          smModal.showModal();
        }
      });

      // initially set the look of the marker
      if (entry.cat[0].slug === this.cfg.slotEntries[this.cfg.activeSlide].dataset.slug) {
        entryMarker.setIcon(redIconSmall);
        // add the active marker to the array
        this.cfg.activeMarkers.push(entryMarker);
      } else {
        entryMarker.setIcon(greyIconSmall);
      }

      // link the marker to each of the entries
      entry.marker = entryMarker;
      this.cfg.markers.push(entryMarker);
    });

    // Reorder markers array to match the sorted posts
    this.cfg.markers = this.cfg.posts.map(post => post.marker);

    // Add keyboard accessibility - allow spacebar to trigger marker click
    document.addEventListener('keydown', e => {
      if (e.key === ' ' || e.code === 'Space' || e.keyCode === 32) {
        if (
          document.activeElement &&
          document.activeElement.classList.contains('leaflet-marker-icon')
        ) {
          e.preventDefault(); // Prevent scrolling on spacebar press
          this.cfg.spaceBarPressedMarker = document.activeElement;
          document.activeElement.click(); // Trigger the click event on the marker icon

          // if the popup was opened by a spacebar press, we need to focus the close button
          // Add a small delay to ensure the popup is fully rendered
          setTimeout(() => {
            if (popupClose && popupClose.length > 0) {
              popupClose[0].focus();
            }
          }, 100);
        }
      }
    });

    this.updateMarker();
    this.centerMap();

    // close Button for map popup
    popupClose[0].addEventListener('click', () => {
      this.closePopup();
    });

    // If user prefers reduced motion, disable animations
    if (this.prefersReducedMotion()) {
      // Disable animations for the map
      map.options.zoomAnimation = false;
      map.options.fadeAnimation = false;
      map.options.markerZoomAnimation = false;
    } else {
    }
  },

  closePopup() {
    this.cfg.popup[0].classList.remove('sm-map__popup--active');
    this.cfg.popupOpen = false;
    this.cfg.animatedMarker?.classList.remove('animated-marker');
    this.cfg.animatedMarker = null;
    if (
      this.cfg.activeEntry?.cat[0].slug === this.cfg.slotEntries[this.cfg.activeSlide].dataset.slug
    ) {
      this.cfg.activeMarker?.setIcon(this.cfg.redIconSmall);
    } else {
      this.cfg.activeMarker?.setIcon(this.cfg.greyIconSmall);
    }
    this.cfg.activeEntry = null;
    this.cfg.activeMarker = null;

    if (this.cfg.spaceBarPressedMarker) {
      // If the spacebar was pressed, focus the marker icon again
      this.cfg.spaceBarPressedMarker.focus();
      this.cfg.spaceBarPressedMarker = null; // Reset the spacebar pressed marker
    }

    this.centerMapToBounds();
  },

  updateMarker() {
    // reset the active markers to none
    this.cfg.activeMarkers = [];
    this.cfg.posts.forEach(entry => {
      entry.marker._icon.setAttribute('alt', ''); // Set the alt attribute for accessibility
      entry.marker._icon.setAttribute('aria-label', entry.title); // Set the aria-label for accessibility
      if (entry.marker == this.cfg.activeMarker) {
        if (entry.cat[0].slug === this.cfg.slotEntries[this.cfg.activeSlide].dataset.slug) {
          entry.marker.setIcon(this.cfg.redIcon);
          // Add tabindex to make active marker tabbable
          if (entry.marker._icon) {
            entry.marker._icon.setAttribute('tabindex', '0');
          }
          // add the active marker to the array
          this.cfg.activeMarkers.push(entry.marker);
        } else {
          entry.marker.setIcon(this.cfg.greyIcon);
          // Remove tabindex to make marker untabbable
          if (entry.marker._icon) {
            entry.marker._icon.removeAttribute('tabindex');
          }
        }
        // readd the animated marker class
        this.cfg.animatedMarker.classList.add('animated-marker');
      } else if (entry.cat[0].slug === this.cfg.slotEntries[this.cfg.activeSlide].dataset.slug) {
        entry.marker.setIcon(this.cfg.redIconSmall);
        // Add tabindex to make active marker tabbable
        if (entry.marker._icon) {
          entry.marker._icon.setAttribute('tabindex', '0');
        }
        // add the active marker to the array
        this.cfg.activeMarkers.push(entry.marker);
      } else {
        entry.marker.setIcon(this.cfg.greyIconSmall);
        // Remove tabindex to make marker untabbable
        if (entry.marker._icon) {
          entry.marker._icon.removeAttribute('tabindex');
        }
      }
    });
  },

  centerMap() {
    if (window.innerWidth > 576) {
      this.centerMapToBounds();
    } else if (this.cfg.activeEntry !== null) {
      this.centerMapToPin();
    } else {
      this.centerMapToBounds();
    }
  },

  setPopupContent(entry) {
    this.cfg.activeEntry = entry;
    this.cfg.popupTitle.innerHTML = entry.title;
    this.cfg.popupExcerpt.innerHTML = entry.excerpt;
    if (entry.link) {
      this.cfg.popupShowMore.href = entry.link.url;

      if (entry.link.title !== '') this.cfg.popupShowMore.innerHTML = entry.link.title;
      else this.cfg.popupShowMore.innerHTML = 'Mehr erfahren';

      this.cfg.popupShowMore.classList.remove('sm-map__popup-show-more--hide');
    } else {
      this.cfg.popupShowMore.classList.add('sm-map__popup-show-more--hide');
    }
    if (entry.image) {
      this.cfg.popupMedia.src = entry.image.sizes.large;
      this.cfg.popupMedia.classList.remove('sm-map__popup-media--hide');
      this.cfg.popupMediaPlaceholder.classList.add('sm-map__popup-placeholder--hide');
    } else {
      this.cfg.popupMedia.classList.add('sm-map__popup-media--hide');
      this.cfg.popupMediaPlaceholder.classList.remove('sm-map__popup-placeholder--hide');
    }

    this.cfg.popupMedia.alt = entry.title;
    if (entry.video) {
      this.cfg.popupMediaContainer.classList.add('sm-map__popup-media-container--active');
      this.cfg.smVideo.src = entry.video.url;
    } else this.cfg.popupMediaContainer.classList.remove('sm-map__popup-media-container--active');

    this.centerMapToPin();
  },

  centerMapToBounds() {
    const markerGroup = L.featureGroup(this.cfg.activeMarkers);
    // Get bounds from the marker group
    const bounds = markerGroup.getBounds();

    // Use different options based on motion preference
    if (this.prefersReducedMotion()) {
      // For reduced motion, disable animation
      this.cfg.map.fitBounds(bounds, {
        paddingBottomRight: [0, 50],
        paddingTopLeft: [0, 150],
        animate: false, // Disable animation
        duration: 0 // Set duration to 0
      });
    } else {
      // Normal animation
      this.cfg.map.fitBounds(bounds, {
        paddingBottomRight: [0, 50],
        paddingTopLeft: [0, 150]
      });
    }
  },

  centerMapToPin() {
    if (this.cfg.activeEntry !== null) {
      const markerGroup = L.featureGroup([
        L.marker([this.cfg.activeEntry.location.lat, this.cfg.activeEntry.location.lng], {
          icon: null
        })
      ]);

      // Get bounds from the marker
      const bounds = markerGroup.getBounds();

      // Use different options based on motion preference
      if (this.prefersReducedMotion()) {
        // For reduced motion, disable animation
        this.cfg.map.fitBounds(bounds, {
          paddingBottomRight: [0, 250],
          paddingTopLeft: [0, 0],
          maxZoom: 14,
          animate: false, // Disable animation
          duration: 0 // Set duration to 0
        });
      } else {
        // Normal animation
        this.cfg.map.fitBounds(bounds, {
          paddingBottomRight: [0, 250],
          paddingTopLeft: [0, 0],
          maxZoom: 14
        });
      }
    }
  },

  /**
   * Initialize.
   */
  init() {
    this.initSlotMachine();

    this.cfg.posts = window.mapProps?.posts;

    if (document.getElementById('map') !== null) {
      this.initMap();
    }
  }
};

export default Starkmacher;
